// extracted by mini-css-extract-plugin
export default {"bodyBox":"src_bodyBox__e2Umk"};